import { treePickerHover, appButtonFontColor, appButtonHoverBGColor, grayText } from 'globals/colors';

/*
 * These styles are structured different due to the way Radium works.
 *
 * Each key will be mapped to a <style> element that is scoped to the key
 * and includes all the rules in the value.
 *
 * So:
 *   '.kustomer': {
 *     a: {
 *       color: 'red'
 *     }
 *   }
 *
 * Creates:
 *   <style>
 *     .kustomer a {
 *       color: 'red';
 *     }
 *   </style>
 *
 * Note: nested styles do not work.
 */

export default {
  '#kustomer-root:not(.userIsTabbing)': {
    'div:focus': {
      outline: 'none',
    },
    'label:focus': {
      outline: 'none',
    },
  },
  '.kustomer': {
    background: 'none !important',
    border: 'none !important',
    boxShadow: 'none !important',
    color: '#222222 !important',
  },
  '.kustomer *': {
    boxSizing: 'border-box !important',
  },
  '.kustomer strong': {
    fontWeight: 'bold',
  },
  '.kustomer em': {
    fontStyle: 'italic',
  },
  '.kustomer .customerMessage': {
    a: {
      color: '#fff',
    },
  },
  '.kustomer .userMessage': {
    a: {
      color: appButtonFontColor,
    },
  },
  '.kustomer .messageInput[contenteditable=true]:empty:before': {
    content: 'attr(placeholder)',
    display: 'block',
    color: grayText,
    fontSize: 12,
    position: 'relative',
  },
  '.kustomer .iconButton': {
    opacity: '.6',
    transition: 'all 150ms',
  },
  '.kustomer .iconButton:hover': {
    opacity: '1',
    transition: 'all 150ms',
  },
  '.kustomer .enterIcon:hover': {
    background: 'rgba(2, 127, 255, .8) !important', // Gross
    transition: 'all 150ms',
  },
  '.kustomer .enterIcon:active': {
    background: 'rgba(2, 127, 255, .8) !important', // Gross
    transition: 'all 150ms',
  },
  '.kustomer img': {
    maxWidth: '100%',
  },
  '.kustomer .messagePreview a': {
    color: grayText,
    textDecoration: 'none',
  },
  '.kustomer .treePicker-node:hover': {
    cursor: 'pointer',
    backgroundColor: treePickerHover,
  },
  '.kustomer .treePicker-arrowWrap:hover': {
    backgroundColor: appButtonHoverBGColor,
  },
  '.kustomer .treePicker-node:hover .treePicker-arrowWrap': {
    backgroundColor: appButtonHoverBGColor,
  },
  '.kustomer .treePicker-breadcrumb:hover': {
    cursor: 'pointer',
    color: appButtonHoverBGColor,
  },
  '.kustomer .treePicker-homeNode:hover': {
    cursor: 'pointer',
    color: appButtonHoverBGColor,
  },
  '.kb-article p': {
    color: '#666;',
    margin: '1rem 0',
    lineHeight: '20px',
  },
  '.kb-article h3': {
    color: '#666;',
    fontWeight: 'bold',
    fontSize: '25px',
    marginTop: '15px',
  },
  '.kb-article h2': {
    color: '#666;',
    fontWeight: 'bold',
    fontSize: '20px',
    marginTop: '15px',
  },
  '.kb-article li': {
    color: '#666;',
    fontSize: '15px',
    marginTop: '15px',
    paddingLeft: '1.5em',
  },
};
